<template>
  <div style="height: 100%; overflow: auto;">
    <div v-if="isLoaded">
      <table style="border-spacing: 0;">
        <thead>
          <tr>
            <th class="head-sticky-cell sticky-column" style="z-index: 4;">Оператор</th>
            <th class="head-sticky-cell">Время</th>

            <!-- Заголовки очередей -->
            <th
              v-for="queue in queues"
              :key="'th_q_' + queue.id"
              class="head-sticky-cell"
            >{{ queue.dname ? queue.dname : queue.name}}</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <!-- Сортировки -->
            <td class="sticky-column pl-2">
              <v-tooltip bottom max-width="400">
                <template #activator="{ on }">
                  <v-btn small icon v-on="on" @click="sortUsersByLastName">
                    <v-icon :color="sortingColorByLastName">{{ sortingIconByLastName }}</v-icon>
                  </v-btn>
                </template>
                <span>Сортировка по Фамилии</span>
              </v-tooltip>

              <v-tooltip bottom max-width="400">
                <template #activator="{ on }">
                  <v-btn small icon v-on="on" @click="sortUsersBySip">
                    <v-icon :color="sortingColorBySip">{{ sortingIconBySip }}</v-icon>
                  </v-btn>
                </template>
                <span>Сортировка по Сип номеру</span>
              </v-tooltip>
            </td>

            <!-- Общее количество pending -->
            <td class="text-center font-weight-bold">{{ totalPendingCount }}</td>

            <!-- Pending звонков у очереди -->
            <td
              v-for="(queue, index) in queues"
              :key="'cals_in_line_' + index"
              class="text-center"
            >
              <div>{{ queue.pendingCount }}</div>
            </td>
          </tr>

          <tr v-for="user of usersInTable" :key="'row_' + user.id">
            <!-- Оператор -->
            <td class="sticky-column">
              <div style="min-width: max-content; padding-inline: 16px">{{ user.title }}</div>
            </td>
            <!-- Таймер -->
            <td>
              <div class="d-flex align-center justify-center" style="gap: 5px;">
                <VuelinerTimer :initialOffset="user.startedAt" />
              </div>
            </td>

            <!-- Статус очереди -->
            <td
              v-for="queue in queues"
              :key="'td_q_' + queue.id"
              style="text-align:center;"
            >
              <v-tooltip bottom max-width="400">
                <template #activator="{ on }">
                  <v-icon
                    v-on="on"
                    :color="getStatusColor(queue.name, user.queuesStatus)"
                    :class="{wiggle: getStatusIcon(queue.name, user.queuesStatus) === 'mdi-phone-ring'}"
                  >{{ getStatusIcon(queue.name, user.queuesStatus) }}</v-icon>
                </template>
                <span>{{ getStatusTitle(queue.name, user.queuesStatus) }}</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    />
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import { axios } from '~/plugins/axios'
import VuelinerTimer from './VuelinerTimer'

export default {
  components: { VuelinerTimer },
  name: 'VuelinerTable',
  props: {
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      queues: [],

      ws: null,
      allUsers: [],
      usersInTable: [],
      statuses: {
        free:           {title: 'Свободен', icon: 'mdi-emoticon-happy-outline', color: null},
        talk:           {title: 'Вызов по другой линии', icon: 'mdi-phone', color: '#c8e6c9'},
        talkCurrent:    {title: 'Вызов по текущей линии', icon: 'mdi-phone', color: '#4caf50'},
        unreachable:    {title: 'Недоступен', icon: 'mdi-account-remove', color: '#f44336'},
        ring:           {title: 'Висит звонок', icon: 'mdi-phone-ring', color: '#cddc39'},
        outgoing_call:  {title: 'Исходящий вызов', icon: 'mdi-arrow-right-circle', color: 'red'},
        outbound_call:  {title: 'Исходящий обзвон', icon: 'mdi-web', color: 'red'},
        lunch:          {title: 'Обед', icon: 'mdi-silverware-fork-knife', color: '#2196f3'},
        smoke:          {title: 'Перерыв', icon: 'mdi-pause', color: '#2196f3'},
        otherwork:      {title: 'Другая работа', icon: 'mdi-briefcase', color: '#2196f3'},
        omni:           {title: 'Омниканальность', icon: 'mdi-forum', color: '#2196f3'},
        parsing:        {title: 'Постобработка', icon: 'mdi-cog', color: '#2196f3'},
        training:       {title: 'Обучение', icon: 'mdi-school', color: '#2196f3'},
        trouble:        {title: 'Проблема', icon: 'mdi-alert', color: '#2196f3'},
      },
      sortingColorByLastName: 'grey',
      sortingIconByLastName: 'mdi mdi-sort-alphabetical-ascending',
      sortingStatusByLastName: 1,

      sortingColorBySip: 'grey',
      sortingIconBySip: 'mdi mdi-sort-numeric-ascending',
      sortingStatusBySip: 1,

      reloadNeeded: true,
    }
  },

  computed: {
    ...mapGetters({}),

    totalPendingCount() {
      let count = 0
      for (const q of this.queues) {
        count += parseInt(q.pendingCount)
      }

      return count
    },
  },

  watch: {},

  methods: {
    ...mapActions({
      loadUsers: 'graphql/loadUsers',
    }),

    getStatusIcon(queue, statuses) {
      let icon = null
      if (queue in statuses) {
        let key = statuses[queue]
        icon = this.statuses[key].icon
      }

      return icon
    },

    getStatusTitle(queue, statuses) {
      let title = null
      if (queue in statuses) {
        let key = statuses[queue]
        title = this.statuses[key].title
      }

      return title
    },

    getStatusColor(queue, statuses) {
      let color = null
      if (queue in statuses) {
        let key = statuses[queue]
        color = this.statuses[key].color
      }

      return color
    },

    sortUsersByLastName() {
      this.usersInTable.sort((a, b) => {
        const ln1 = a.lastName
        const ln2 = b.lastName

        if (ln1 < ln2) return -1 * this.sortingStatusByLastName
        else if (ln1 > ln2) return 1 * this.sortingStatusByLastName
        else return 0
      })

      this.sortingColorBySip = 'grey'
      this.sortingStatusBySip = 1

      this.sortingColorByLastName = 'success'
      this.sortingIconByLastName = this.sortingStatusByLastName > 0 ? 'mdi mdi-sort-alphabetical-ascending' : 'mdi mdi-sort-alphabetical-descending'
      this.sortingStatusByLastName *= -1
    },

    sortUsersBySip() {
      this.usersInTable.sort((a, b) => {
        const ln1 = a.sip
        const ln2 = b.sip

        if (ln1 < ln2) return -1 * this.sortingStatusBySip
        else if (ln1 > ln2) return 1 * this.sortingStatusBySip
        else return 0
      })

      this.sortingStatusByLastName = 1
      this.sortingColorByLastName = 'grey'

      this.sortingColorBySip = 'success'
      this.sortingIconBySip = this.sortingStatusBySip > 0 ? 'mdi mdi-sort-numeric-ascending' : 'mdi mdi-sort-numeric-descending'
      this.sortingStatusBySip *= -1
    },


    async loadData() {
      this.isLoaded = false

      await this.loadAllUsers()
      await this.loadQueues()
      this.startWs()

      this.isLoaded = true
    },

    async loadAllUsers() {
      const graphQuery = {
        query: `{
          users {
            data {
              id
              first_name
              last_name
              title
              sip {name}
            }
          }
        }`
      }

      const response = await this.loadUsers(graphQuery)
      this.allUsers = response.data.map(user => ({
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
        sip: user.sip?.name,
        title: `[${user.sip?.name}] ${user.last_name} ${user.first_name}`,
        
        queuesStatus: {},
      }))
    },

    async loadQueues() {
      const payload = {}
      if (this.widget.params.isAllProjects === false) {
        payload.projects_ids = this.widget.params.projects
      }
      const data = await axios.post('/api/me/get-available-queues', payload)
        .then(response => response.data)

      for (const q of data) {
        q.pendingCount = 0
      }

      this.queues = data
    },

    startWs() {
      const wsProtocol = location.protocol === 'http:' ? 'ws' : 'wss'

      this.ws = new WebSocket(`${wsProtocol}://${location.host}/ws`)

      this.ws.onopen = () => {
        console.log(
          '%cСокет открыт',
          'background: green;color:white;font-size:1.5rem;padding:0.3em 0.7em;'
        )

        for (const q of this.queues) {
          try {
            this.ws.send(
              JSON.stringify({
                type: "Action",
                action: "AddListenQueue",
                queue: q.name,
              })
            );
          } catch (e) {
            console.log(e);
          }
        }
      }

      this.ws.onmessage = this.wsMessageHandler

      this.ws.onclose = () => {
        console.log(
          "%cСокет закрыт",
          "background-color:orangered;color:white;font-size:1.5rem;padding:0.3em 0.7em;"
        )

        this.ws = null
        this.usersInTable.length = 0
        this.queues.length = 0
        this.allUsers.length = 0
        this.isLoaded = false

        if (this.reloadNeeded) setTimeout(this.loadData, 2000)
      }

      this.ws.onerror = (err) => {
        console.log("Ошибка сокета\n", err)
      }
    },

    wsMessageHandler(ev) {
      const event = JSON.parse(ev.data)

      switch (event.Event) {
        case 'AgentState': {
          const user = this.allUsers.find(item => item.sip === event.Agent)
          if (!user) return 

          if (event.StartedAt) this.$set(user, 'startedAt', Date.now() / 1000 - parseInt(event.StartedAt, 10))
          else this.$set(user, 'startedAt', null)

          if (!this.usersInTable.find(item => item.sip === user.sip)) {
            this.usersInTable.push(user)
          }

          this.sortUsersByLastName()
          this.sortingStatusByLastName = 1

          break
        }
        case 'AgentQueueState': {
          const user = this.allUsers.find(item => item.sip === event.Agent)
          if (!user) return 
          let status = event.Status
          if (status === 'talk' && event.HasCall > 0) status = 'talkCurrent'
          this.$set(user.queuesStatus, event.Queue, status)

          break
        }
        case 'PendingCallsCount': {
          const found = this.queues.find(q => q.name === event.Queue)
          if (!found) return

          found.pendingCount = event.Count
          break
        }
        case 'RemoveAgent': {
          const foundUserIndex = this.usersInTable.findIndex(user => user.sip === event.Agent)
          if (foundUserIndex === undefined) return

          const foundUser = this.usersInTable[foundUserIndex]
          delete foundUser.queuesStatus[event.Queue]

          if (Object.keys(foundUser.queuesStatus).length === 0) {
            this.usersInTable.splice(foundUserIndex, 1)
          }
          break
        }

      }
    },
  },

  async mounted() {
    await this.loadData()
  },

  beforeDestroy() {
    this.reloadNeeded = false
    this.ws.close()
    this.ws = null
  },
}
</script>


<style scoped lang="scss">
.head-sticky-cell {
  position: sticky;
  top: 0;
}
.sticky-column {
  position: sticky;
  left: 0;
  z-index: 2;
}
table {
  background-color: var(--table-bg);
  width: 100%;

  & thead th {
    background-color: var(--table-bg);
    color: var(--th-color);
    font-size: 12px;
    text-align: start;
    padding: 0 16px;
    z-index: 3;
    box-shadow: inset 0 -1px 0 var(--border-color);
  }
  & tbody td {
    border-bottom: thin solid var(--border-color);
    padding-block: 2px;
  }
  & tbody .sticky-column {
    background-color: var(--table-bg);
  }

  tbody tr:hover td {
    background-color: var(--hover-bg);
  }

  .theme--dark & {
    --table-bg: #1E1E1E;
    --th-color: #ffffffb3;
    --border-color: #ffffff1f;
    --hover-bg: #616161;
  }
  .theme--light & {
    --table-bg: #FFFFFF;
    --th-color: #0009;
    --border-color: #0000001f;
    --hover-bg: #eeeeee;
  }
}

.wiggle {
  animation: wiggle 150ms linear infinite alternate;

  @keyframes wiggle {
    from {
      rotate: -30deg;
    }
    to {
      rotate: 30deg;
    }
  }
}

</style>